import * as R from 'ramda';
import React, {Component} from 'react';

import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ImageIcon from '@material-ui/icons/Image';
import VideoCamIcon from '@material-ui/icons/Videocam';
import CardContent from "@material-ui/core/CardContent";
import { TextField, SimpleShowLayout } from "react-admin";
import {DoctorReferenceField} from "../../misc/customFields";

const styles = {
    container: { minWidth: "35em", marginLeft: "1em" },
    rightAlignedCell: { textAlign: "center" },
    leftAlignedCell: { textAlign: "left", color: "rgba(0, 0, 0, 0.54)" },
    inlineField: {
        display: "inline-block",
        width: "50%"
    }
};

class NoteView extends Component {

    render() {
        const {classes, record} = this.props;
        const note = R.pathOr(null, ["completionSummary", "note"], record);
        if (!note) {
            return null;
        }
        const attachments = R.pathOr([], ["attachments"], note);

        return (
            <Paper className={classes.container}>
                <CardContent>
                    <Typography className={classes.rightAlignedCell} variant="subheading">
                        Note:
                    </Typography>
                    <SimpleShowLayout {...this.props}>
                        <Typography variant="body1" className={classes.leftAlignedCell}>
                            Creator:
                        </Typography>
                        <DoctorReferenceField {...this.props} source="completionSummary.note.creator.id" />
                        <TextField label="Text:" source={"completionSummary.note.text"} />
                        {attachments &&
                            <>
                            <Typography variant="body1" className={classes.leftAlignedCell}>
                            Attachments:
                            </Typography>
                            <List dense>
                                {attachments.map((elm, i) => {
                                    let isImage = true;
                                    let Icon = ImageIcon;
                                    let url = R.pathOr(null, ['originalImageUrl'], elm);
                                    if (!url) {
                                        url = R.pathOr(null, ['originalVideoUrl'], elm);
                                        isImage = false;
                                    }
                                    if (!isImage) {
                                        Icon = VideoCamIcon;
                                    }


                                    return(
                                    <ListItem><a target="_blank" href={url}><ListItemIcon><Icon/></ListItemIcon></a></ListItem>
                                    )
                                })}
                            </List>
                            </>
                         }
                    </SimpleShowLayout>
                </CardContent>
            </Paper>
        )
    }
}

export default withStyles(styles)(NoteView);